export const addTransaction = ()=>{
    return "/api/transaction/razorpay"
}